import api from '@/rest-api'

export default {
    getReceiptInfo(data) {
        return api.post(`/receipt/extract`, data)
    },
}